import { render } from "./ResilienceLab.vue?vue&type=template&id=53108382&scoped=true"
import script from "./ResilienceLab.vue?vue&type=script&lang=js"
export * from "./ResilienceLab.vue?vue&type=script&lang=js"

import "./ResilienceLab.vue?vue&type=style&index=0&id=53108382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53108382"]])

export default __exports__